import { TIME_FILTERS_VALUES } from '../../constants'
import { nowDate } from '../../../common/helpers/dateHelpers'
import { addHours, startOfDay, endOfDay, startOfWeek, endOfWeek, addDays, addWeeks, subDays, subWeeks, startOfMonth, addMonths, subMonths, endOfMonth, subMinutes } from 'date-fns'

const getDateRange = (filter, timezoneOffset) => {
    const now = nowDate(timezoneOffset)
    const startOfThisWeek = startOfWeek(now, {weekStartsOn: 7})
    const endOfThisWeek = endOfWeek(now, {weekStartsOn: 7})
    const startOfToday = startOfDay(now)
    const endOfToday = endOfDay(now)
    const startOfThisMonth = startOfMonth(now)

    switch(filter.time) {
        case TIME_FILTERS_VALUES.RecentNext:
            const dayOfWeek = now.getDay()
            return {
                from: subMinutes(now, 120),
                to: dayOfWeek >= 5 ? addHours(now, (7-dayOfWeek)*24 + 48) : addHours(now, 48)
            }
        case TIME_FILTERS_VALUES.Today:
            return {
                from: startOfToday,
                to: endOfToday
            }
        case TIME_FILTERS_VALUES.Tomorrow:
            return {
                from: addDays(startOfToday, 1),
                to: addDays(endOfToday, 1)
            }
        case TIME_FILTERS_VALUES.Yesterday:
            return {
                from: subDays(startOfToday, 1),
                to: subDays(endOfToday, 1)
            }
        case TIME_FILTERS_VALUES.ThisWeek:
            return {
                from: startOfThisWeek,
                to: endOfThisWeek
            }
        case TIME_FILTERS_VALUES.ThisMonth:
            return {
                from: startOfThisMonth,
                to: endOfMonth(now)
            }
        case TIME_FILTERS_VALUES.NextWeek:
            return {
                from: addWeeks(startOfThisWeek, 1),
                to: addWeeks(endOfThisWeek, 1)
            }
        case TIME_FILTERS_VALUES.PreviousWeek:
            return {
                from: subWeeks(startOfThisWeek, 1),
                to: subWeeks(endOfThisWeek, 1)
            }
        case TIME_FILTERS_VALUES.NextMonth:
            const startOfNextMonth =  addMonths(startOfThisMonth, 1)
            return {
                from: startOfNextMonth,
                to: endOfMonth(startOfNextMonth),
            }
        case TIME_FILTERS_VALUES.PreviousMonth:
            const startOfPreviousMonth = subMonths(startOfThisMonth, 1)
            return {
                from: startOfPreviousMonth,
                to: endOfMonth(startOfPreviousMonth),
            }
        case TIME_FILTERS_VALUES.Custom:
            if(!filter.dateRange){
                return {
                    from: now,
                    to: undefined,
                }
            }
            
            return filter.dateRange
            
        default:
            return filter.dateRange
    }
}

export { getDateRange }
